export const addPendingTranslationKeys = (setPendingTranslationKeys, keys) => {
  if (!keys.length) return;
  setPendingTranslationKeys((prev) => {
    const next = new Set(prev);
    keys.forEach((key) => next.add(key));
    return next;
  });
};

export const removePendingTranslationKeys = (setPendingTranslationKeys, keys) => {
  if (!keys.length) return;
  setPendingTranslationKeys((prev) => {
    const next = new Set(prev);
    keys.forEach((key) => next.delete(key));
    return next;
  });
};
